<section class="main">
    <div class="table-title">
        <div class="head-button">
            <button class="r-btn" (click)="onRefreshTable()"><i class="icon bi bi-arrow-clockwise"></i></button>
        </div>
        <div class="act-search-bar">
            <app-search-bar (searchValue)="onSearchInput($event)" [value]="'WinOls'"
                            [newInputValue]="allMasterService.searchString()"></app-search-bar>
            <div class="filtering-buttons">
                <button type="button" class="filter-trigger" (click)="openAdvancedSearchSettings()"
                        [class.is-active]="allMasterService.openAdvanceSettings() || filterCount() > 0"
                        [attr.aria-expanded]="allMasterService.openAdvanceSettings()"
                        [attr.aria-label]="filterCount() > 0 ? 'Filters, ' + filterCount() + ' active' : 'Filters'">
                    <i class="bi bi-funnel" aria-hidden="true"></i>
                    <span>Filters</span>
                    @if (filterCount() > 0) {
                        <span class="count-filter" aria-hidden="true">{{ filterCount() }}</span>
                    }
                </button>
            </div>
        </div>
    </div>

    @if (allMasterService.openAdvanceSettings()) {
        <div>
            <app-master-filters [displayedColumns]="allMasterService.displayedColumns()"
                                (masterFiltersClosed)="onAdvancedSettingClosed($event)"
                                (selectedFilters)="selectFilters($event)"
                                (filterCount)="updateFilterCount($event)">

            </app-master-filters>
        </div>
    }

    @if (initialLoad()) {
        <div>
            <app-skeleton-table></app-skeleton-table>
        </div>
    } @else {
        @if (allMasterService.isTableLoading()) {
            <div class="spinner-container">
                <mat-spinner diameter="50"></mat-spinner>
            </div>
        } @else {
            @if (!isTableEmpty()) {
            <div class="table-container"
                 infinite-scroll
                 [scrollWindow]="false"
                 [infiniteScrollDistance]="2"
                 (scrolled)="allMasterService.onScroll()"
            >
                <app-master-records-table [allMasters]="allMasterService.allMasters()"
                                          [sortDirectionValues]="allMasterService.sortDirectionValues()"
                                          [expandedMaster]="allMasterService.expandedMaster()"
                                          [displayedTableHeaders]="allMasterService.displayedTableHeaders()"
                                          [displayedColumns]="allMasterService.displayedColumns()"
                                          [allVersions]="tuningService.allVersions()"
                                          [displayedVersionColumns]="allMasterService.displayedVersionColumns()"
                                          (editItemDetails)="editItemDetails($event)"
                                          (deleteOriginalItem)="deleteOriginalItems($event)"
                                          (downloadOriginalFile)="downloadFileFromTable($event)"
                                          (deleteTuningRecord)="deleteTuningRecordFromTable($event)"
                                          (downloadTuningRecord)="downloadTuningRecordFromTable($event)"
                                          (toggleExpandedRow)="toggleExpandedRow($event)"
                                          (changeSortDirection)="changeSortDirection($event)"
                ></app-master-records-table>

            </div>
        } @else {
            <div class="empty-table-wrapper">
                <div class="empty-table">NO RESULTS</div>
            </div>
        }
    }}


</section>

